import React, { createContext, useContext, useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AdminLayout } from "@/pages/manage/AdminLayout";

const KEY = "bj_manage_business";
const ManageCtx = createContext(null);

export function useManageBusiness() {
  return useContext(ManageCtx);
}

// Wraps all /manage routes: tracks which business the baker is managing and
// renders the shared admin sidebar layout around the routed page.
export function ManageShell() {
  const { user } = useAuth();
  const [businessId, setBusinessId] = useState(
    () => localStorage.getItem(KEY) || user?.business_id || "baking_jays"
  );

  useEffect(() => {
    localStorage.setItem(KEY, businessId);
  }, [businessId]);

  return (
    <ManageCtx.Provider value={{ businessId, setBusinessId }}>
      <AdminLayout businessId={businessId} onBusinessChange={setBusinessId}>
        <Outlet />
      </AdminLayout>
    </ManageCtx.Provider>
  );
}
